import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(resetEntity);

import { all, select, put } from 'redux-saga/effects';
export function resetEntity(entity) {
  var keys;
  return regeneratorRuntime.wrap(function resetEntity$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(entity.keys);

        case 2:
          keys = _context.sent;
          _context.next = 5;
          return all(keys.map(function (key) {
            return put(entity.resetAction({
              key: key
            }));
          }));

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}